import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { MasterTableEditWarning } from '../MasterTableEditWarning';
import { AccountingTypeForm } from './AccountingTypeForm';

type Props = ComponentProps<typeof AccountingTypeForm>;

export const AccountingTypeFormDrawer: FC<Props> = ({
  type,
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'accounting-type'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      {type === 'edit' && <MasterTableEditWarning marginBottom={8} />}
      <AccountingTypeForm
        type={type}
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Drawer>
  );
};
